import React from 'react';

export const MedexOVALogo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 120, height: 32 },
    default: { width: 180, height: 48 },
    large: { width: 240, height: 64 }
  };
  
  const { width, height } = sizes[size] || sizes.default;
  
  return (
    <svg 
      viewBox="0 0 180 48" 
      width={width} 
      height={height} 
      className={className}
      aria-label="MedexOVA Logo"
    >
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="50%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>
        <linearGradient id="ovaGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#10b981" />
          <stop offset="100%" stopColor="#06b6d4" />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Background hexagon pattern */}
      <g opacity="0.3">
        <path 
          d="M12 8 L20 12 L20 22 L12 26 L4 22 L4 12 Z" 
          fill="none" 
          stroke="url(#logoGradient)" 
          strokeWidth="0.5"
        />
        <path 
          d="M28 8 L36 12 L36 22 L28 26 L20 22 L20 12 Z" 
          fill="none" 
          stroke="url(#logoGradient)" 
          strokeWidth="0.5"
        />
      </g>
      
      {/* Main text - MEDEX */}
      <text 
        x="2" 
        y="32" 
        fontFamily="Space Grotesk, sans-serif" 
        fontWeight="700" 
        fontSize="22"
        fill="white"
        letterSpacing="-0.5"
      >
        MEDEX
      </text>
      
      {/* OVA with gradient */}
      <text 
        x="82" 
        y="32" 
        fontFamily="Space Grotesk, sans-serif" 
        fontWeight="700" 
        fontSize="22"
        fill="url(#ovaGradient)"
        letterSpacing="-0.5"
        filter="url(#glow)"
      >
        OVA
      </text>
      
      {/* Accent dot */}
      <circle 
        cx="130" 
        cy="28" 
        r="3" 
        fill="url(#logoGradient)"
      />
      
      {/* Tagline */}
      <text 
        x="2" 
        y="44" 
        fontFamily="JetBrains Mono, monospace" 
        fontWeight="400" 
        fontSize="6"
        fill="#64748b"
        letterSpacing="1.5"
      >
        AI MOBILITY INFRASTRUCTURE
      </text>
      
      {/* Animated pulse ring around dot */}
      <circle 
        cx="130" 
        cy="28" 
        r="5" 
        fill="none"
        stroke="url(#logoGradient)"
        strokeWidth="0.5"
        opacity="0.5"
      >
        <animate 
          attributeName="r" 
          values="5;8;5" 
          dur="2s" 
          repeatCount="indefinite"
        />
        <animate 
          attributeName="opacity" 
          values="0.5;0;0.5" 
          dur="2s" 
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};

export const MedexOVAIcon = ({ className = "", size = 32 }) => {
  return (
    <svg 
      viewBox="0 0 48 48" 
      width={size} 
      height={size} 
      className={className}
      aria-label="MedexOVA Icon"
    >
      <defs>
        <linearGradient id="iconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="50%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>
      </defs>
      
      {/* Outer hexagon */}
      <path 
        d="M24 4 L42 14 L42 34 L24 44 L6 34 L6 14 Z" 
        fill="none" 
        stroke="url(#iconGradient)" 
        strokeWidth="2"
      />
      
      {/* Inner pattern - network nodes */}
      <circle cx="24" cy="14" r="2" fill="url(#iconGradient)" />
      <circle cx="14" cy="24" r="2" fill="url(#iconGradient)" />
      <circle cx="34" cy="24" r="2" fill="url(#iconGradient)" />
      <circle cx="24" cy="34" r="2" fill="url(#iconGradient)" />
      <circle cx="24" cy="24" r="3" fill="url(#iconGradient)" />
      
      {/* Connection lines */}
      <line x1="24" y1="14" x2="24" y2="21" stroke="url(#iconGradient)" strokeWidth="1" opacity="0.6" />
      <line x1="14" y1="24" x2="21" y2="24" stroke="url(#iconGradient)" strokeWidth="1" opacity="0.6" />
      <line x1="27" y1="24" x2="34" y2="24" stroke="url(#iconGradient)" strokeWidth="1" opacity="0.6" />
      <line x1="24" y1="27" x2="24" y2="34" stroke="url(#iconGradient)" strokeWidth="1" opacity="0.6" />
    </svg>
  );
};

export default MedexOVALogo;
